import { lazy, Suspense } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Spin } from 'antd';
import AppLayout from '../layout/AppLayout';
import Home from '../pages/Home';
import Login from '../pages/Login';
import Interview from '../pages/Interview';
import Report from '../pages/Report';
import Profile from '../pages/Profile';
import Invite from '../pages/Invite';
import QuestionnairePage from '../pages/Questionnaire';

// 面试经验页面懒加载
const InterviewExperience = lazy(() => import('../pages/InterviewExperience'));
const InterviewExperienceDetail = lazy(() => import('../pages/InterviewExperienceDetail'));

// 懒加载包装器
const LazyWrapper = ({ children }: { children: React.ReactNode }) => (
  <Suspense
    fallback={
      <div className="flex min-h-[60vh] items-center justify-center">
        <Spin size="large" />
      </div>
    }
  >
    {children}
  </Suspense>
);

export const AppRouter = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<AppLayout />}>
          <Route index element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/invite" element={<Invite />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/report/:interviewNumber" element={<Report />} />
          <Route path="/interview/:interviewNumber" element={<Interview />} />
          <Route path="/questionnaire/:questionnaireNumber" element={<QuestionnairePage />} />
          {/* 面试经验路由 */}
          <Route
            path="/interview-experience"
            element={
              <LazyWrapper>
                <InterviewExperience />
              </LazyWrapper>
            }
          />
          <Route
            path="/interview-experience/:experienceNumber"
            element={
              <LazyWrapper>
                <InterviewExperienceDetail />
              </LazyWrapper>
            }
          />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};
